export default {"src":"/_next/static/media/follow-video.318702db.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};